import { Component, OnInit, signal } from '@angular/core';
import { IMPORTS } from './_imports';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService } from '../../../services/dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { Enums } from '../../../shared/enums';
import { Utils } from '../../../shared/utils';
import { AvailableFlowDefinitionsCsvDescription, AvailableFlowDefinitions, AvailableFlowDefinitionsDescription } from '../../../models/dashboard.model';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';

@Component({
    selector: 'available-flow-definitions',
    templateUrl: './available-flow-definitions.component.html',
    styleUrl: './available-flow-definitions.component.scss',
    standalone: true,
    imports: IMPORTS,
})
export class AvailableFlowDefinitionsComponent implements OnInit {
    // #region [Type props]
    AvailableFlowDefinitionsDescription = AvailableFlowDefinitionsDescription;
    // #endregion

    // #region [signals]
    $results = signal(null as AvailableFlowDefinitions);
    $showResults = signal(false);
    $topPatriarchs = signal([] as any[]);
    $topOrganizations = signal([] as any[]);
    // #endregion

    constructor(
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private dashboardService: DashboardService,
    ) { }

    ngOnInit() { }

    async getResults() {
        this.spinner.show();

        const response = await this.dashboardService.getResultsAvailableFlowDefinitions();

        if (!response.isSuccess) {
            this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        Utils.setSignal(this.$results, response.data);
        Utils.setSignal(this.$topPatriarchs, response.data.topPatriarchs.map(x => ({ name: x.pivot.split(' - ')[0], value: x.count })));
        Utils.setSignal(this.$topOrganizations, response.data.topOrganizations.map(x => ({ name: x.pivot.split(' - ')[0], value: x.count })));

        setTimeout(() => {
            this.$showResults.set(true);
            this.spinner.hide();
        }, 500);
    }

    async exportCsv() {
        this.spinner.show();

        try {
            const response = await this.dashboardService.exportCsvAvailableFlowDefinitions();

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                this.spinner.hide();
                return;
            }

            if (response.data.length == 0) {
                this.toastr.warning(Enums.Messages.CsvNoRecordsError, Enums.Messages.Warning, Utils.getToastrErrorOptions());
                return;
            }

            const headers = Object.keys(response.data[0]).map(x => AvailableFlowDefinitionsCsvDescription.get(x));
            const splittedTime = (new Date()).toLocaleString().split(', ');
            const timeString = splittedTime[0].split('/').reverse().join('') + '_' + splittedTime[1].replaceAll(':', '');
            const filename = `E-Flow Definições de Fluxo disponíveis (${timeString})`;
            const csvOptions = {
                fieldSeparator: ';',
                showLabels: true,
                headers: [...new Set(headers)],
                nullToEmptyString: true
            };

            new AngularCsv(response.data, filename, csvOptions);

            this.toastr.success(Enums.Messages.CsvGenerationSuccess, Enums.Messages.Success);
        } catch (error) {
            this.toastr.error(Enums.Messages.CsvExportError, Enums.Messages.Error, Utils.getToastrErrorOptions());
            this.spinner.hide();
            console.error(error);
        } finally {
            this.spinner.hide();
        }
    }

    // #region [===== private methods =====]
    // #endregion
}
